import { Breakpoints } from '../../components/Experimenter/types';

export const getMediaQueryList = (screenMaxWidth: Breakpoints = Breakpoints.MD) =>
  (typeof window !== 'undefined' && window && window.matchMedia(`(max-width: ${screenMaxWidth})`)) || null;
